<template>
    <div class="system-params-container">
      <h1 class="page-title mb-4">系统参数管理</h1>
  
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <el-row :gutter="20" type="flex" align="middle" justify="space-between">
            <el-col :span="16">
              <el-input
                placeholder="搜索参数类型、编码、值或描述"
                v-model="searchQuery"
                clearable
                @clear="handleSearch"
                @input="handleSearch"
                prefix-icon="el-icon-search"
                style="width: 300px; margin-right: 15px;"
              >
                <el-tooltip slot="append" effect="dark" content="支持输入1个及以上字符进行搜索" placement="top">
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </el-input>
              <el-select 
                v-model="filterType" 
                placeholder="按类型筛选" 
                @change="handleTypeFilter" 
                clearable
                style="width: 200px;"
              >
                <el-option
                  v-for="type in dictTypes"
                  :key="type"
                  :label="type"
                  :value="type">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8" style="text-align: right">
              <el-checkbox 
                v-if="!isAdmin"
                v-model="onlyMyParams" 
                @change="handleMyParamsFilter"
                class="my-params-checkbox">
                <span>仅限我创建的</span>
              </el-checkbox>
            </el-col>
          </el-row>
        </div>
  
        <el-table
          :data="filteredDictList"
          style="width: 100%"
          border
          v-loading="loading"
          stripe
        >
          <el-table-column prop="id" label="ID" width="80"></el-table-column>
          <el-table-column prop="dictType" label="参数类型" width="150"></el-table-column>
          <el-table-column prop="dictCode" label="参数编码" width="150"></el-table-column>
          <el-table-column prop="dictValue" label="参数值">
            <template slot-scope="scope">
              <span v-if="scope.row.isJson && scope.row.jsonValue" class="json-value-badge">JSON</span>
              <span v-if="!scope.row.isJson">{{ scope.row.dictValue }}</span>
              <span v-else class="json-preview">{{ formatJsonPreview(scope.row.jsonValue) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="dictDesc" label="参数描述" width="200"></el-table-column>
          <el-table-column v-if="isAdmin" prop="region" label="适用范围" width="120">
            <template slot-scope="scope">
              <el-tag :type="getRegionTagType(scope.row.region)">
                {{ getRegionText(scope.row.region) }}
              </el-tag>
            </template>
          </el-table-column>
                  <el-table-column prop="isEnabled" label="状态" width="100">
          <template slot-scope="scope">
            <!-- 管理员或数据所有者可编辑状态 -->
            <div v-if="isAdmin || scope.row.userId === currentUserId">
              <el-tooltip :content="getStatusTooltip(scope.row.isEnabled)" placement="top" :open-delay="500">
                <el-switch
                  v-model="scope.row.isEnabled"
                  :active-value="1"
                  :inactive-value="0"
                  @change="handleStatusChange(scope.row)"
                ></el-switch>
              </el-tooltip>
            </div>
            <!-- 其他情况只显示状态标签 -->
            <div v-else>
              <el-tag :type="scope.row.isEnabled === 1 ? 'success' : 'info'">
                {{ scope.row.isEnabled === 1 ? '启用' : '禁用' }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
                  <el-table-column 
          label="操作" 
          width="200" 
          fixed="right">
          <template slot-scope="scope">
            <!-- 管理员可以编辑所有参数，非管理员只能编辑自己创建的参数 -->
            <div v-if="isAdmin || scope.row.userId === currentUserId">
              <el-button
                size="mini"
                type="primary"
                plain
                icon="el-icon-edit"
                @click="handleEdit(scope.row)"
              >编辑</el-button>
              <el-button
                size="mini"
                type="danger"
                plain
                icon="el-icon-delete"
                @click="handleDelete(scope.row)"
              >删除</el-button>
            </div>
            <!-- 非管理员查看他人创建的参数时不显示操作按钮 -->
            <div v-else class="no-operation-tip">
              <el-tag type="info" size="mini">无操作权限</el-tag>
            </div>
          </template>
        </el-table-column>
        </el-table>
        
        <div class="pagination-container">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :total="totalCount"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </el-card>
  
      <!-- 添加/编辑参数对话框 -->
      <el-dialog 
        :title="dialogTitle" 
        :visible.sync="dialogVisible" 
        width="600px"
        :close-on-click-modal="false"
      >
        <el-form 
          :model="dictForm" 
          :rules="rules" 
          ref="dictForm" 
          label-width="100px"
        >
          <el-form-item label="参数类型" prop="dictType">
            <div class="type-input-group">
              <el-select 
                v-model="dictForm.dictType" 
                placeholder="选择已有类型或输入新类型" 
                allow-create
                default-first-option
                style="width: calc(100% - 40px)"
              >
                <div slot="prefix" class="el-input__icon el-icon-info" style="margin-right: 8px;"></div>
                <template slot="prefix">
                </template>
                <el-option
                  v-for="type in dictTypes"
                  :key="type"
                  :label="type"
                  :value="type">
                </el-option>
              </el-select>
              <el-button 
                type="primary" 
                icon="el-icon-plus" 
                size="small" 
                @click="handleAddNewType" 
                title="创建新参数类型"
                class="add-type-button">
              </el-button>
            </div>
            <div class="form-tip" v-if="isCreatingNewType">
              <i class="el-icon-info"></i>
              <span>正在创建新的参数类型: <b>{{ dictForm.dictType }}</b></span>
            </div>
          </el-form-item>
          
          <el-form-item label="参数编码" prop="dictCode">
            <el-input v-model="dictForm.dictCode" placeholder="请输入参数编码，如：WARNING"></el-input>
          </el-form-item>
          
          <el-form-item label="参数描述" prop="dictDesc">
            <el-input v-model="dictForm.dictDesc" placeholder="请输入参数描述"></el-input>
          </el-form-item>
          
          <el-form-item label="值类型">
            <el-radio-group v-model="dictForm.isJson">
              <el-radio :label="false">字符串值</el-radio>
              <el-radio :label="true">JSON值</el-radio>
            </el-radio-group>
          </el-form-item>
          
          <el-form-item label="参数值" prop="dictValue" v-if="!dictForm.isJson">
            <el-input v-model="dictForm.dictValue" placeholder="请输入字符串值"></el-input>
          </el-form-item>
          
          <el-form-item label="JSON值" prop="jsonValue" v-if="dictForm.isJson">
            <el-input 
              type="textarea" 
              v-model="dictForm.jsonValue" 
              :autosize="{ minRows: 4, maxRows: 8 }" 
              placeholder="请输入JSON格式的值，如：{ &quot;key&quot;: &quot;value&quot; }"
            ></el-input>
          </el-form-item>
          
          <el-form-item label="适用范围" prop="region" v-if="isAdmin">
            <el-select v-model="dictForm.region" placeholder="请选择适用范围" style="width: 100%">
              <el-option :value="0" label="当前用户"></el-option>
              <el-option :value="1" label="仅管理员"></el-option>
              <el-option :value="2" label="全局所有用户"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="排序序号" prop="sortOrder">
            <el-input-number v-model="dictForm.sortOrder" :min="0" :step="10"></el-input-number>
          </el-form-item>
          
          <el-form-item label="状态" prop="isEnabled">
            <el-switch
              v-model="dictForm.isEnabled"
              :active-value="1"
              :inactive-value="0"
              active-text="启用"
              inactive-text="禁用">
            </el-switch>
          </el-form-item>
        </el-form>
        
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm" :loading="submitting">确 定</el-button>
        </span>
      </el-dialog>
  
      <!-- JSON预览对话框 -->
      <el-dialog 
        title="JSON数据预览" 
        :visible.sync="jsonPreviewVisible" 
        width="60%"
      >
        <pre class="json-preview-content">{{ formattedJsonPreview }}</pre>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { 
    getAllDictsByUserScope, 
    getAllDictTypes, 
    createDict, 
    updateDict, 
    deleteDict,
    getDictsByTypeAndUserScope
  } from '@/api/dict'
  import { getCurrentUserRoles } from '@/api/auth'
  
  export default {
    name: 'SystemParams',
    inject: {
      registerNavButtons: {
        default: () => () => {}
      },
      unregisterNavButtons: {
        default: () => () => {}
      }
    },
    data() {
      // 校验JSON格式
      const validateJSON = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入JSON值'))
          return
        }
        
        try {
          JSON.parse(value)
          callback()
        } catch (error) {
          callback(new Error('JSON格式不正确，请检查'))
        }
      }
      
      return {
        loading: false,
        submitting: false,
        searchQuery: '',
        filterType: '',
        dictList: [],
        dictTypes: [],
        dialogVisible: false,
        dialogTitle: '添加参数',
        jsonPreviewVisible: false,
        formattedJsonPreview: '',
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
        isAdmin: false,
        currentUserId: null,
        onlyMyParams: false,
        dictForm: {
          id: null,
          dictType: '',
          dictCode: '',
          dictDesc: '',
          dictValue: '',
          isJson: false,
          jsonValue: '',
          region: 0,
          sortOrder: 0,
          isEnabled: 1
        },
        rules: {
          dictType: [
            { required: true, message: '请选择或输入参数类型', trigger: 'change' }
          ],
          dictCode: [
            { required: true, message: '请输入参数编码', trigger: 'blur' },
            { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
          ],
          dictValue: [
            { required: true, message: '请输入参数值', trigger: 'blur' }
          ],
          jsonValue: [
            { required: true, message: '请输入JSON值', trigger: 'blur' },
            { validator: validateJSON, trigger: 'blur' }
          ],
          region: [
            { required: true, message: '请选择适用范围', trigger: 'change' }
          ]
        }
      }
    },
    computed: {
      filteredDictList() {
        const startIndex = (this.currentPage - 1) * this.pageSize
        const endIndex = startIndex + this.pageSize
        
        let filteredList = this.dictList
        
        // 搜索筛选
        if (this.searchQuery) {
          const query = this.searchQuery.toLowerCase()
          filteredList = filteredList.filter(dict => 
            (dict.dictType && dict.dictType.toLowerCase().includes(query)) ||
            (dict.dictCode && dict.dictCode.toLowerCase().includes(query)) ||
            (dict.dictDesc && dict.dictDesc.toLowerCase().includes(query)) ||
            (dict.dictValue && dict.dictValue.toLowerCase().includes(query))
          )
        }
        
        // 类型筛选
        if (this.filterType) {
          filteredList = filteredList.filter(dict => dict.dictType === this.filterType)
        }
        
        // 仅限我创建的筛选
        if (!this.isAdmin && this.onlyMyParams) {
          filteredList = filteredList.filter(dict => 
            dict.userId === this.currentUserId
          )
        }
        
        this.totalCount = filteredList.length
        
        return filteredList.slice(startIndex, endIndex)
      },
      
      // 判断是否正在创建新类型
      isCreatingNewType() {
        if (!this.dictForm.dictType || !this.dictTypes || !this.dictTypes.length) {
          return false
        }
        // 如果当前输入的类型不在现有类型列表中，则认为是创建新类型
        return !this.dictTypes.includes(this.dictForm.dictType)
      }
    },
    async created() {
      await this.fetchUserInfo()
      await this.fetchDictTypes()
      await this.fetchDictList()
      
      // 注册导航按钮
      this.registerNavButtons([
        {
          id: 'add-dict',
          text: '添加参数',
          icon: 'el-icon-plus',
          type: 'primary',
          handler: this.handleAdd
        }
      ])
    },
    
    beforeDestroy() {
      // 在组件销毁前注销按钮
      this.unregisterNavButtons()
    },
    methods: {
      async fetchUserInfo() {
        try {
          // 从token中解析用户ID
          const token = localStorage.getItem('token')
          if (!token) {
            console.warn('未找到登录token')
            return
          }
          
          // 获取用户ID
          const userId = localStorage.getItem('userId')
          if (userId) {
            this.currentUserId = parseInt(userId, 10)
          } else {
            // 临时用于开发测试
            this.currentUserId = 1
          }
          
          console.log('当前用户ID:', this.currentUserId)
          
          // 获取用户角色信息
          const response = await getCurrentUserRoles(userId)
          
          if (response && response.code === 200) {
            const roles = response.data
            console.log('用户角色列表:', roles)
            // 检查是否包含ADMIN角色
            this.isAdmin = Array.isArray(roles) && roles.includes('ADMIN') && userId === "1" // 临时测试，userId为1时，强制为管理员
            console.log('是否管理员:', this.isAdmin)
          } else {
            console.error('获取用户角色响应异常:', response)
            this.isAdmin = false
          }
        } catch (error) {
          console.error('获取用户角色出错:', error)
          this.isAdmin = false
        }
      },
      
      async fetchDictList() {
        this.loading = true
        try {
          const response = await getAllDictsByUserScope()
          console.log('获取系统参数接口响应:', response)
          if (response && response.code === 200) {
            const dictData = response.data || {}
            
            // 将分类的字典数据转为扁平数组
            let allDicts = []
            for (const type in dictData) {
              if (dictData.hasOwnProperty(type) && Array.isArray(dictData[type])) {
                allDicts = [...allDicts, ...dictData[type]]
              }
            }
            
            console.log('处理后的数据字典列表:', allDicts)
            this.dictList = allDicts
            this.totalCount = allDicts.length
            
            if (allDicts.length === 0) {
              this.$message.info('暂无系统参数数据')
            }
          } else {
            console.error('获取系统参数列表失败:', response)
            this.$message.error(response?.data?.message || '获取系统参数列表失败')
          }
        } catch (error) {
          console.error('获取系统参数列表出错:', error)
          this.$message.error('获取系统参数列表出错')
        } finally {
          this.loading = false
        }
      },
      
      async fetchDictTypes() {
        try {
          const response = await getAllDictTypes()
          console.log('获取数据字典类型响应:', response)
          if (response && response.code === 200) {
            this.dictTypes = response.data || []
            console.log('数据字典类型列表:', this.dictTypes)
          } else {
            console.error('获取数据字典类型失败:', response)
          }
        } catch (error) {
          console.error('获取参数类型列表出错:', error)
        }
      },
      
      async fetchDictsByType(type) {
        if (!type) {
          await this.fetchDictList()
          return
        }
        
        this.loading = true
        try {
          const response = await getDictsByTypeAndUserScope(type)
          if (response.code === 200) {
            this.dictList = response.data || []
            this.totalCount = this.dictList.length
          } else {
            this.$message.error(`获取类型 ${type} 的参数列表失败`)
          }
        } catch (error) {
          console.error(`获取类型 ${type} 的参数列表出错:`, error)
          this.$message.error(`获取类型 ${type} 的参数列表出错`)
        } finally {
          this.loading = false
        }
      },
      
      handleAdd() {
        this.dialogTitle = '添加参数'
        this.dictForm = {
          id: null,
          dictType: '',
          dictCode: '',
          dictDesc: '',
          dictValue: '',
          isJson: false,
          jsonValue: '',
          region: 0, // 默认为当前用户
          sortOrder: 0,
          isEnabled: 1
        }
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.dictForm && this.$refs.dictForm.clearValidate()
        })
      },
      
      handleEdit(row) {
        this.dialogTitle = '编辑参数'
        this.dictForm = {
          id: row.id,
          dictType: row.dictType,
          dictCode: row.dictCode,
          dictDesc: row.dictDesc,
          dictValue: row.dictValue || '',
          isJson: !!row.isJson,
          jsonValue: row.jsonValue || '',
          region: row.region,
          sortOrder: row.sortOrder || 0,
          isEnabled: row.isEnabled
        }
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.dictForm && this.$refs.dictForm.clearValidate()
        })
      },
      
      async handleDelete(row) {
        try {
          await this.$confirm(`确定要删除参数 "${row.dictCode}" 吗？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          
          this.loading = true
          const response = await deleteDict(row.id)
          
          if (response.code === 200) {
            this.$message.success('删除成功')
            this.fetchDictList()
          } else {
            this.$message.error(response.data?.message || '删除失败')
          }
        } catch (error) {
          if (error !== 'cancel') {
            console.error('删除参数出错:', error)
            this.$message.error(response.data?.message ||'删除参数出错')
          }
        } finally {
          this.loading = false
        }
      },
      
      async submitForm() {
        this.$refs.dictForm.validate(async valid => {
          if (!valid) return
          
          try {
            this.submitting = true
            
            // 如果是JSON类型，验证并处理JSON值
            if (this.dictForm.isJson) {
              try {
                JSON.parse(this.dictForm.jsonValue)
              } catch (error) {
                this.$message.error('JSON格式不正确，请检查')
                this.submitting = false
                return
              }
            }
            
            // 构造提交的数据对象
            const formData = {
              dictType: this.dictForm.dictType,
              dictCode: this.dictForm.dictCode,
              dictDesc: this.dictForm.dictDesc,
              dictValue: this.dictForm.isJson ? '' : this.dictForm.dictValue,
              isJson: this.dictForm.isJson,
              jsonValue: this.dictForm.isJson ? this.dictForm.jsonValue : '',
              region: this.isAdmin ? this.dictForm.region : 0, // 非管理员固定为当前用户
              sortOrder: this.dictForm.sortOrder,
              isEnabled: this.dictForm.isEnabled
            }
            
            let response
            if (this.dictForm.id) {
              // 更新
              response = await updateDict(this.dictForm.id, formData)
            } else {
              // 创建
              response = await createDict(formData)
            }
            
            if (response.code === 200) {
              this.$message.success(this.dictForm.id ? '更新成功' : '添加成功')
              this.dialogVisible = false
              this.fetchDictList()
            } else {
              this.$message.error(response.data?.message || (this.dictForm.id ? '更新失败' : '添加失败'))
            }
          } catch (error) {
            console.error('提交表单出错:', error)
            this.$message.error('提交表单出错')
          } finally {
            this.submitting = false
          }
        })
      },
      
      handleSearch() {
        this.currentPage = 1
      },
      
      handleTypeFilter(type) {
        this.currentPage = 1
        this.fetchDictsByType(type)
      },
      
      handleCurrentChange(page) {
        this.currentPage = page
      },
      
      // 处理"仅限我创建的"筛选
      handleMyParamsFilter() {
        console.log('仅限我创建的筛选状态:', this.onlyMyParams)
        this.currentPage = 1
        // 重新应用筛选
        this.fetchDictList()
      },
      
      // 获取状态提示文本
      getStatusTooltip(status) {
        return status === 1 ? '点击切换为禁用状态' : '点击切换为启用状态'
      },
      
      // 处理状态改变
      async handleStatusChange(row) {
        try {
          console.log(`更改参数 ${row.dictCode} 的状态为:`, row.isEnabled)
          
          // 构造更新数据
          const updateData = {
            dictType: row.dictType,
            dictCode: row.dictCode,
            dictDesc: row.dictDesc,
            dictValue: row.isJson ? '' : row.dictValue,
            isJson: row.isJson,
            jsonValue: row.isJson ? row.jsonValue : '',
            region: row.region,
            sortOrder: row.sortOrder,
            isEnabled: row.isEnabled // 更新后的状态
          }
          
          // 调用更新API
          const response = await updateDict(row.id, updateData)
          
          if (response.code === 200) {
            this.$message.success(`状态已${row.isEnabled === 1 ? '启用' : '禁用'}`)
          } else {
            this.$message.error('状态更新失败')
            // 恢复原状态
            row.isEnabled = row.isEnabled === 1 ? 0 : 1
          }
        } catch (error) {
          console.error('更新状态出错:', error)
          this.$message.error('更新状态出错')
          // 恢复原状态
          row.isEnabled = row.isEnabled === 1 ? 0 : 1
        }
      },
      
      // 处理添加新类型的按钮点击
      handleAddNewType() {
        this.$prompt('请输入新的参数类型名称', '创建新参数类型', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          // inputPattern: /^[A-Z0-9_]+$/,
          // inputErrorMessage: '参数类型只能包含大写字母、数字和下划线'
        }).then(({ value }) => {
          if (value && value.trim()) {
            const newType = value.trim().toUpperCase()
            
            // 检查是否已存在
            if (this.dictTypes.includes(newType)) {
              this.$message.warning(`参数类型 ${newType} 已存在`)
              return
            }
            
            // 将新类型添加到类型列表
            this.dictTypes.push(newType)
            
            // 设置为当前选中的类型
            this.dictForm.dictType = newType
            
            this.$message.success(`已创建新参数类型: ${newType}`)
          }
        }).catch(() => {
          this.$message.info('已取消创建')
        })
      },
      
      getRegionText(region) {
        switch (region) {
          case 0: return '当前用户'
          case 1: return '仅管理员'
          case 2: return '全局所有用户'
          default: return '未知'
        }
      },
      
      getRegionTagType(region) {
        switch (region) {
          case 0: return 'info'
          case 1: return 'warning'
          case 2: return 'success'
          default: return 'info'
        }
      },
      
      formatJsonPreview(jsonString) {
        if (!jsonString) return ''
        try {
          const json = JSON.parse(jsonString)
          // 返回简短预览，最多显示前30个字符
          const preview = JSON.stringify(json).slice(0, 30)
          return preview.length < JSON.stringify(json).length ? `${preview}...` : preview
        } catch (error) {
          return '无效的JSON'
        }
      },
      
      showJsonPreview(jsonString) {
        try {
          const json = JSON.parse(jsonString)
          this.formattedJsonPreview = JSON.stringify(json, null, 2)
          this.jsonPreviewVisible = true
        } catch (error) {
          this.$message.error('无效的JSON格式')
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .system-params-container {
    padding: 20px;
  }
  
  .page-title {
    font-size: 24px;
    font-weight: 500;
    color: #303133;
  }
  
  .box-card {
    margin-bottom: 20px;
  }
  
  .pagination-container {
    margin-top: 20px;
    text-align: center;
  }
  
  .json-value-badge {
    background-color: #409EFF;
    color: white;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 8px;
  }
  
  .json-preview {
    cursor: pointer;
    color: #409EFF;
  }
  
  .json-preview-content {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    overflow: auto;
    max-height: 500px;
    white-space: pre-wrap;
    word-break: break-all;
  }
  
  .form-tip {
    font-size: 13px;
    color: #E6A23C;
    margin-top: 5px;
    padding: 8px;
    background-color: #fdf6ec;
    border-radius: 4px;
    border-left: 3px solid #E6A23C;
  }
  
  .form-tip i {
    margin-right: 5px;
  }
  
  .type-input-group {
    display: flex;
    align-items: center;
  }
  
  .add-type-button {
    margin-left: 5px;
  }
  
  .my-params-checkbox {
    margin-right: 10px;
  }
  
  .no-operation-tip {
    text-align: center;
    color: #909399;
    font-size: 12px;
  }
  
  /* 状态开关样式 */
  .el-switch {
    margin-left: 8px;
  }
  
  .el-tooltip__popper {
    font-size: 12px;
  }
  </style>